var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodHygiene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2904",
    "data-name": "Group 2904",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.482,
    height: 72.711,
    viewBox: "0 0 149.482 72.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 149.482,
    height: 72.711,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 11.879,
    height: 11.879,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2903",
    "data-name": "Group 2903",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2902",
    "data-name": "Group 2902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2901",
    "data-name": "Group 2901",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10679",
    "data-name": "Path 10679",
    d: "M146.807,0a2.677,2.677,0,0,1,2.676,2.676V70.034a2.677,2.677,0,0,1-2.676,2.676H110.195a2.677,2.677,0,0,1-2.676-2.676V65.78a1.193,1.193,0,0,0-.41-1,1.744,1.744,0,0,0-1.1-.323.479.479,0,0,1-.242-.065H2.676A2.676,2.676,0,0,1,0,61.718V2.675A2.676,2.676,0,0,1,2.676,0Z",
    transform: "translate(0 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10680",
    "data-name": "Path 10680",
    d: "M148.34,2.5H4.209A1.712,1.712,0,0,0,2.5,4.208V63.252A1.711,1.711,0,0,0,4.209,64.96H107.564a.48.48,0,0,1,.26.076,2.556,2.556,0,0,1,1.428.528,2.164,2.164,0,0,1,.767,1.749v4.254a1.711,1.711,0,0,0,1.709,1.708H148.34a1.711,1.711,0,0,0,1.708-1.708V4.208A1.713,1.713,0,0,0,148.34,2.5",
    transform: "translate(-1.533 -1.532)",
    fill: "#a9c500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10681",
    "data-name": "Path 10681",
    d: "M21.914,27.08V18.775h6.053V20.18H23.7v1.966h3.687v1.405H23.7v3.53Z",
    transform: "translate(-13.439 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10682",
    "data-name": "Path 10682",
    d: "M40.432,22.754a5.009,5.009,0,0,1,.4-2.13,3.906,3.906,0,0,1,.822-1.139,3.451,3.451,0,0,1,1.141-.748,5.117,5.117,0,0,1,1.9-.329,4.29,4.29,0,0,1,3.123,1.139A4.212,4.212,0,0,1,49,22.715a4.2,4.2,0,0,1-1.162,3.147A4.256,4.256,0,0,1,44.727,27a4.3,4.3,0,0,1-3.132-1.13,4.142,4.142,0,0,1-1.163-3.113m1.837-.056a2.99,2.99,0,0,0,.693,2.139,2.485,2.485,0,0,0,3.509.005,3.048,3.048,0,0,0,.684-2.167,3,3,0,0,0-.666-2.13,2.575,2.575,0,0,0-3.545.009,3.011,3.011,0,0,0-.675,2.144",
    transform: "translate(-24.795 -11.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10683",
    "data-name": "Path 10683",
    d: "M65.241,22.754a5.009,5.009,0,0,1,.4-2.13,3.906,3.906,0,0,1,.822-1.139,3.451,3.451,0,0,1,1.141-.748,5.117,5.117,0,0,1,1.9-.329,4.29,4.29,0,0,1,3.123,1.139,4.212,4.212,0,0,1,1.172,3.167,4.2,4.2,0,0,1-1.162,3.147A4.256,4.256,0,0,1,69.536,27a4.3,4.3,0,0,1-3.132-1.13,4.142,4.142,0,0,1-1.163-3.113m1.837-.056a2.99,2.99,0,0,0,.693,2.139,2.485,2.485,0,0,0,3.509.005,3.048,3.048,0,0,0,.684-2.167,3,3,0,0,0-.666-2.13,2.575,2.575,0,0,0-3.545.009,3.011,3.011,0,0,0-.675,2.144",
    transform: "translate(-40.008 -11.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10684",
    "data-name": "Path 10684",
    d: "M90.97,18.775h3.258a6.757,6.757,0,0,1,1.68.159,2.993,2.993,0,0,1,1.332.765,3.588,3.588,0,0,1,.843,1.346,5.787,5.787,0,0,1,.289,1.963,5.152,5.152,0,0,1-.271,1.767,3.633,3.633,0,0,1-.946,1.467,3.188,3.188,0,0,1-1.253.663,5.71,5.71,0,0,1-1.578.176H90.97Zm1.783,1.405v5.5h1.331a5.172,5.172,0,0,0,1.078-.079,1.686,1.686,0,0,0,.72-.346,1.736,1.736,0,0,0,.467-.8,5.118,5.118,0,0,0,.181-1.521,4.688,4.688,0,0,0-.181-1.479,1.882,1.882,0,0,0-.506-.8,1.74,1.74,0,0,0-.825-.391,8.574,8.574,0,0,0-1.464-.079Z",
    transform: "translate(-55.786 -11.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10685",
    "data-name": "Path 10685",
    d: "M122.047,27.08V18.775h1.622v3.269h3.179V18.775h1.622V27.08h-1.622V23.448h-3.179V27.08Z",
    transform: "translate(-74.844 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10686",
    "data-name": "Path 10686",
    d: "M143.781,27.08v-3.5l-2.943-4.81h1.9l1.891,3.286,1.853-3.286h1.869L145.4,23.6V27.08Z",
    transform: "translate(-86.367 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10687",
    "data-name": "Path 10687",
    d: "M165.645,23.8V22.4h3.5v3.308a4.372,4.372,0,0,1-1.477.9,5.225,5.225,0,0,1-1.96.388,4.286,4.286,0,0,1-2.2-.547,3.432,3.432,0,0,1-1.408-1.564,5.194,5.194,0,0,1-.471-2.212,4.911,4.911,0,0,1,.526-2.306,3.6,3.6,0,0,1,1.54-1.547,4.042,4.042,0,0,1,1.924-.413,3.746,3.746,0,0,1,2.337.649,2.944,2.944,0,0,1,1.083,1.793l-1.611.312a1.762,1.762,0,0,0-.639-.966,1.886,1.886,0,0,0-1.17-.354,2.163,2.163,0,0,0-1.691.7,3,3,0,0,0-.628,2.068,3.327,3.327,0,0,0,.636,2.218,2.091,2.091,0,0,0,1.666.739,2.711,2.711,0,0,0,1.022-.207,3.48,3.48,0,0,0,.88-.5V23.8Z",
    transform: "translate(-99.117 -11.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10688",
    "data-name": "Path 10688",
    d: "M192.988,27.08V18.775h5.958V20.18h-4.335v1.841h4.033v1.4h-4.033v2.261H199.1v1.4Z",
    transform: "translate(-118.348 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10689",
    "data-name": "Path 10689",
    d: "M212.39,27.08V18.775h1.578l3.289,5.547V18.775h1.507V27.08h-1.628L213.9,21.664V27.08Z",
    transform: "translate(-130.246 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10690",
    "data-name": "Path 10690",
    d: "M233.305,27.08V18.775h5.957V20.18h-4.335v1.841h4.034v1.4h-4.034v2.261h4.489v1.4Z",
    transform: "translate(-143.072 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10691",
    "data-name": "Path 10691",
    d: "M257.263,27.081V18.775h3.4A5.625,5.625,0,0,1,262.53,19a1.858,1.858,0,0,1,.931.8,2.464,2.464,0,0,1,.349,1.308,2.267,2.267,0,0,1-.53,1.544,2.5,2.5,0,0,1-1.583.768,3.783,3.783,0,0,1,.866.7,9.476,9.476,0,0,1,.92,1.348l.977,1.621h-1.933l-1.169-1.807a11.634,11.634,0,0,0-.852-1.221,1.239,1.239,0,0,0-.486-.346,2.574,2.574,0,0,0-.813-.093h-.328v3.467Zm1.616-4.793h1.2a5.95,5.95,0,0,0,1.453-.1.872.872,0,0,0,.453-.351,1.111,1.111,0,0,0,.164-.623,1.024,1.024,0,0,0-.215-.677.981.981,0,0,0-.609-.326q-.2-.028-1.179-.028h-1.261Z",
    transform: "translate(-157.764 -11.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10692",
    "data-name": "Path 10692",
    d: "M284.055,27.08H282.3l-.7-1.887h-3.2l-.661,1.887h-1.714l3.118-8.306h1.709Zm-2.975-3.286-1.1-3.082L278.9,23.794Z",
    transform: "translate(-169.269 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10693",
    "data-name": "Path 10693",
    d: "M297.755,27.08v-6.9H295.38V18.775h6.361V20.18h-2.37v6.9Z",
    transform: "translate(-181.139 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10694",
    "data-name": "Path 10694",
    d: "M322.6,27.08V18.775h1.573l3.276,5.547V18.775h1.5V27.08h-1.621L324.1,21.664V27.08Z",
    transform: "translate(-197.83 -11.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10695",
    "data-name": "Path 10695",
    d: "M346.716,23.8V22.4H350.2v3.308a4.354,4.354,0,0,1-1.472.9,5.181,5.181,0,0,1-1.952.388,4.256,4.256,0,0,1-2.189-.547,3.43,3.43,0,0,1-1.4-1.564,5.215,5.215,0,0,1-.47-2.212,4.925,4.925,0,0,1,.524-2.306,3.591,3.591,0,0,1,1.534-1.547,4.011,4.011,0,0,1,1.916-.413,3.722,3.722,0,0,1,2.329.649,2.946,2.946,0,0,1,1.078,1.793l-1.605.312a1.76,1.76,0,0,0-.636-.966,1.872,1.872,0,0,0-1.165-.354,2.15,2.15,0,0,0-1.685.7,3.008,3.008,0,0,0-.625,2.068,3.335,3.335,0,0,0,.633,2.218,2.079,2.079,0,0,0,1.66.739,2.692,2.692,0,0,0,1.018-.207,3.459,3.459,0,0,0,.876-.5V23.8Z",
    transform: "translate(-210.166 -11.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M150.264,55.75H1.749v1.16H125.84l1.451,2.279,1.895,2.974,1.895-2.974,1.451-2.279h17.732Z",
    transform: "translate(-1.072 -34.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10697",
    "data-name": "Path 10697",
    d: "M323.139,96.07A12.57,12.57,0,1,1,310.57,83.5a12.57,12.57,0,0,1,12.57,12.57",
    transform: "translate(-182.746 -51.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10698",
    "data-name": "Path 10698",
    d: "M315.129,107.366l3.279-.34a2.812,2.812,0,0,0,.831,1.762,2.256,2.256,0,0,0,1.592.649,2.211,2.211,0,0,0,1.745-.837,3.809,3.809,0,0,0,.714-2.523,3.457,3.457,0,0,0-.708-2.371,2.361,2.361,0,0,0-1.844-.791,3.351,3.351,0,0,0-2.541,1.253l-2.67-.386,1.686-8.933h8.7v3.079h-6.206l-.515,2.915a5.029,5.029,0,0,1,5.96,1.042,5.735,5.735,0,0,1,1.522,4.133,6.2,6.2,0,0,1-1.229,3.782,5.45,5.45,0,0,1-4.648,2.271,5.769,5.769,0,0,1-3.875-1.276,5.257,5.257,0,0,1-1.791-3.431",
    transform: "translate(-193.25 -58.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10699",
    "data-name": "Path 10699",
    d: "M256.984,112.354v-1.988h-3.6v-.935l3.79-5.382H258v5.382h1.122v.935H258v1.988Zm0-2.923v-3.745l-2.6,3.745Z",
    transform: "translate(-155.384 -63.807)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2888",
    "data-name": "Group 2888",
    transform: "translate(96.527 37.755)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2887",
    "data-name": "Group 2887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2886",
    "data-name": "Group 2886",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10700",
    "data-name": "Path 10700",
    d: "M259.421,99.657a6.959,6.959,0,0,1,0,9.841l-9.841-9.841a6.958,6.958,0,0,1,9.841,0",
    transform: "translate(-249.58 -97.618)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10701",
    "data-name": "Path 10701",
    d: "M242.5,103.511a7.639,7.639,0,1,1,7.639,7.638,7.64,7.64,0,0,1-7.639-7.638m.774,0a6.865,6.865,0,1,0,6.865-6.866,6.873,6.873,0,0,0-6.865,6.866",
    transform: "translate(-148.709 -58.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10702",
    "data-name": "Path 10702",
    d: "M200.178,110.8l1.02-.136a2.241,2.241,0,0,0,.6,1.249,1.474,1.474,0,0,0,1.028.383,1.646,1.646,0,0,0,1.215-.5,1.681,1.681,0,0,0,.5-1.235,1.564,1.564,0,0,0-.459-1.158,1.587,1.587,0,0,0-1.167-.456,2.932,2.932,0,0,0-.72.113l.113-.9a1.529,1.529,0,0,0,.164.012,2.1,2.1,0,0,0,1.173-.34,1.163,1.163,0,0,0,.521-1.048,1.238,1.238,0,0,0-.38-.929,1.348,1.348,0,0,0-.98-.369,1.389,1.389,0,0,0-.991.374,1.879,1.879,0,0,0-.51,1.122l-1.02-.181a2.622,2.622,0,0,1,.85-1.59,2.46,2.46,0,0,1,1.649-.564,2.719,2.719,0,0,1,1.252.292,2.117,2.117,0,0,1,.876.8,2.046,2.046,0,0,1,.3,1.071,1.754,1.754,0,0,1-.289.98,1.975,1.975,0,0,1-.856.7,1.926,1.926,0,0,1,1.144.705,2.146,2.146,0,0,1,.408,1.34,2.453,2.453,0,0,1-.793,1.844,2.792,2.792,0,0,1-2.006.756,2.608,2.608,0,0,1-1.815-.652,2.52,2.52,0,0,1-.825-1.688",
    transform: "translate(-122.757 -64.176)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2891",
    "data-name": "Group 2891",
    transform: "translate(75.223 37.755)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2890",
    "data-name": "Group 2890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10703",
    "data-name": "Path 10703",
    d: "M204.337,99.658a6.959,6.959,0,0,1,0,9.841L194.5,99.658a6.958,6.958,0,0,1,9.841,0",
    transform: "translate(-194.496 -97.619)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10704",
    "data-name": "Path 10704",
    d: "M187.459,103.511a7.639,7.639,0,1,1,7.639,7.638,7.639,7.639,0,0,1-7.639-7.638m.774,0a6.865,6.865,0,1,0,6.865-6.866,6.873,6.873,0,0,0-6.865,6.866",
    transform: "translate(-114.957 -58.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10705",
    "data-name": "Path 10705",
    d: "M150.564,111.32v.98h-5.49a1.8,1.8,0,0,1,.119-.708,3.749,3.749,0,0,1,.672-1.1,10.486,10.486,0,0,1,1.334-1.258,11.287,11.287,0,0,0,1.83-1.759,2.1,2.1,0,0,0,.476-1.226,1.362,1.362,0,0,0-.433-1.023,1.564,1.564,0,0,0-1.13-.417,1.592,1.592,0,0,0-1.178.442,1.67,1.67,0,0,0-.447,1.224l-1.048-.108a2.581,2.581,0,0,1,.81-1.788,2.765,2.765,0,0,1,1.887-.615,2.632,2.632,0,0,1,1.892.663,2.176,2.176,0,0,1,.7,1.643,2.489,2.489,0,0,1-.2.98,3.792,3.792,0,0,1-.677,1.014,16.422,16.422,0,0,1-1.572,1.462q-.918.77-1.178,1.045a3.374,3.374,0,0,0-.43.553Z",
    transform: "translate(-88.965 -63.753)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2894",
    "data-name": "Group 2894",
    transform: "translate(53.919 37.787)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2893",
    "data-name": "Group 2893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2892",
    "data-name": "Group 2892",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10706",
    "data-name": "Path 10706",
    d: "M149.254,99.741a6.959,6.959,0,0,1,0,9.841l-9.841-9.841a6.958,6.958,0,0,1,9.841,0",
    transform: "translate(-139.413 -97.702)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10707",
    "data-name": "Path 10707",
    d: "M95.237,113.181h-1.02v-6.5a5.262,5.262,0,0,1-.966.7,6.888,6.888,0,0,1-1.074.527v-.986a6.159,6.159,0,0,0,1.5-.974,3.837,3.837,0,0,0,.907-1.11h.657Z",
    transform: "translate(-56.527 -64.293)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2897",
    "data-name": "Group 2897",
    transform: "translate(32.647 37.787)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2896",
    "data-name": "Group 2896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2895",
    "data-name": "Group 2895",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10708",
    "data-name": "Path 10708",
    d: "M94.254,99.741a6.959,6.959,0,0,1,0,9.841l-9.841-9.841a6.958,6.958,0,0,1,9.841,0",
    transform: "translate(-84.413 -97.702)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10709",
    "data-name": "Path 10709",
    d: "M132.42,103.511a7.639,7.639,0,1,1,7.639,7.638,7.64,7.64,0,0,1-7.639-7.638m.774,0a6.865,6.865,0,1,0,6.865-6.866,6.873,6.873,0,0,0-6.865,6.866",
    transform: "translate(-81.205 -58.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10710",
    "data-name": "Path 10710",
    d: "M77.382,103.511a7.639,7.639,0,1,1,7.639,7.638,7.64,7.64,0,0,1-7.639-7.638m.774,0a6.865,6.865,0,1,0,6.865-6.866,6.874,6.874,0,0,0-6.865,6.866",
    transform: "translate(-47.454 -58.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10711",
    "data-name": "Path 10711",
    d: "M35.092,108.9a7.606,7.606,0,0,1,.3-2.371,2.952,2.952,0,0,1,.9-1.385,2.3,2.3,0,0,1,1.5-.487,2.458,2.458,0,0,1,1.173.269,2.245,2.245,0,0,1,.833.776,4.177,4.177,0,0,1,.516,1.235,8.21,8.21,0,0,1,.187,1.963,7.626,7.626,0,0,1-.3,2.36,2.948,2.948,0,0,1-.9,1.388,2.527,2.527,0,0,1-3.4-.371,5.473,5.473,0,0,1-.821-3.376m1.048,0a5.208,5.208,0,0,0,.478,2.722,1.368,1.368,0,0,0,2.363,0,7.978,7.978,0,0,0,0-5.444,1.421,1.421,0,0,0-1.192-.674,1.308,1.308,0,0,0-1.122.595,5.269,5.269,0,0,0-.527,2.8",
    transform: "translate(-21.52 -64.181)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2900",
    "data-name": "Group 2900",
    transform: "translate(11.343 37.82)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2899",
    "data-name": "Group 2899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2898",
    "data-name": "Group 2898",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10712",
    "data-name": "Path 10712",
    d: "M39.171,99.825a6.959,6.959,0,0,1,0,9.841L29.33,99.825a6.958,6.958,0,0,1,9.841,0",
    transform: "translate(-29.33 -97.786)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10713",
    "data-name": "Path 10713",
    d: "M22.343,103.511a7.639,7.639,0,1,1,7.639,7.638,7.64,7.64,0,0,1-7.639-7.638m.774,0a6.865,6.865,0,1,0,6.865-6.866,6.874,6.874,0,0,0-6.865,6.866",
    transform: "translate(-13.702 -58.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10714",
    "data-name": "Path 10714",
    d: "M298.666,169.421l-1.088-3.045h.667l.77,2.254.746-2.254h.652l-1.091,3.045Z",
    transform: "translate(-182.487 -102.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10715",
    "data-name": "Path 10715",
    d: "M305.941,169.421v-3.045H308.2v.515h-1.643v.675h1.529v.513h-1.529v.829h1.7v.513Z",
    transform: "translate(-187.615 -102.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10716",
    "data-name": "Path 10716",
    d: "M313.5,169.421v-3.045H314.8a2.211,2.211,0,0,1,.709.082.7.7,0,0,1,.354.292.88.88,0,0,1,.133.48.812.812,0,0,1-.2.566.969.969,0,0,1-.6.282,1.439,1.439,0,0,1,.33.255,3.5,3.5,0,0,1,.35.495l.372.594h-.735l-.445-.663a4.216,4.216,0,0,0-.324-.448.466.466,0,0,0-.185-.126,1,1,0,0,0-.309-.034h-.125v1.271Zm.615-1.757h.455a2.329,2.329,0,0,0,.552-.038.331.331,0,0,0,.173-.129.4.4,0,0,0,.062-.229.364.364,0,0,0-.082-.248.378.378,0,0,0-.232-.12c-.05-.007-.2-.01-.449-.01h-.48Z",
    transform: "translate(-192.253 -102.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10717",
    "data-name": "Path 10717",
    d: "M321.552,169.421V168.14l-1.115-1.764h.721l.717,1.2.7-1.2h.709l-1.119,1.768v1.277Z",
    transform: "translate(-196.505 -102.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10718",
    "data-name": "Path 10718",
    d: "M333.136,168.22v-.513h1.326v1.213a1.669,1.669,0,0,1-.56.33,2.036,2.036,0,0,1-.742.142,1.668,1.668,0,0,1-.833-.2,1.275,1.275,0,0,1-.534-.573,1.856,1.856,0,0,1-.178-.811,1.751,1.751,0,0,1,.2-.846,1.343,1.343,0,0,1,.584-.567,1.58,1.58,0,0,1,.729-.151,1.456,1.456,0,0,1,.886.237,1.073,1.073,0,0,1,.41.657l-.611.114a.642.642,0,0,0-.242-.354.728.728,0,0,0-.443-.13.833.833,0,0,0-.641.255,1.076,1.076,0,0,0-.238.758,1.193,1.193,0,0,0,.241.813.805.805,0,0,0,.632.271,1.056,1.056,0,0,0,.388-.076,1.333,1.333,0,0,0,.333-.184v-.386Z",
    transform: "translate(-203.359 -101.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10719",
    "data-name": "Path 10719",
    d: "M340.342,167.836a1.93,1.93,0,0,1,.139-.781,1.434,1.434,0,0,1,.283-.418,1.191,1.191,0,0,1,.394-.274,1.676,1.676,0,0,1,.656-.12,1.429,1.429,0,0,1,1.077.417,1.867,1.867,0,0,1,0,2.315,1.419,1.419,0,0,1-1.072.417,1.434,1.434,0,0,1-1.08-.415,1.573,1.573,0,0,1-.4-1.141m.633-.021a1.14,1.14,0,0,0,.239.784.821.821,0,0,0,1.21,0,1.164,1.164,0,0,0,.236-.794,1.146,1.146,0,0,0-.229-.781.851.851,0,0,0-1.223,0,1.148,1.148,0,0,0-.233.786",
    transform: "translate(-208.712 -101.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10720",
    "data-name": "Path 10720",
    d: "M349.117,167.836a1.93,1.93,0,0,1,.139-.781,1.427,1.427,0,0,1,.284-.418,1.187,1.187,0,0,1,.394-.274,1.675,1.675,0,0,1,.656-.12,1.429,1.429,0,0,1,1.077.417,1.867,1.867,0,0,1,0,2.315,1.6,1.6,0,0,1-2.152,0,1.572,1.572,0,0,1-.4-1.141m.634-.021a1.139,1.139,0,0,0,.239.784.821.821,0,0,0,1.21,0,1.165,1.165,0,0,0,.236-.794,1.146,1.146,0,0,0-.229-.781.851.851,0,0,0-1.223,0,1.149,1.149,0,0,0-.233.786",
    transform: "translate(-214.093 -101.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10721",
    "data-name": "Path 10721",
    d: "M358.21,166.376h1.124a2.2,2.2,0,0,1,.579.058,1.019,1.019,0,0,1,.46.281,1.331,1.331,0,0,1,.291.493,2.245,2.245,0,0,1,.1.72,2.007,2.007,0,0,1-.094.648,1.348,1.348,0,0,1-.326.538,1.078,1.078,0,0,1-.432.243,1.874,1.874,0,0,1-.544.064H358.21Zm.615.515v2.017h.459a1.673,1.673,0,0,0,.372-.029.565.565,0,0,0,.248-.127.643.643,0,0,0,.161-.294,2,2,0,0,0,.062-.558,1.828,1.828,0,0,0-.062-.542.7.7,0,0,0-.174-.295.587.587,0,0,0-.285-.143,2.8,2.8,0,0,0-.5-.029Z",
    transform: "translate(-219.669 -102.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10722",
    "data-name": "Path 10722",
    d: "M315.644,17.085c-.226,0-.355,0-.709.613A5.345,5.345,0,0,0,314,20.147a.609.609,0,0,0,.709.678v5.253h1.032V18.084c0-.419.128-1-.1-1",
    transform: "translate(-192.558 -10.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10723",
    "data-name": "Path 10723",
    d: "M185.793,18.291v1.886h-.349V18.291H184.9v1.886h-.349V18.291h-.461v1.885a1.5,1.5,0,0,0,.383.934v5.753h1.386V21.111a1.462,1.462,0,0,0,.391-.934V18.291Z",
    transform: "translate(-112.894 -11.217)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodHygiene);
export default __webpack_public_path__ + "static/media/food-hygiene.a9ff4f2265253b0e9c0dfded843724d2.svg";
export { ForwardRef as ReactComponent };